import React, { useEffect } from 'react'

import { GENDER_RADIO_INPUT_VALUES } from '@js/common/constants'
import { validationMessage } from '@js/common/validation'

import CTA from '@f/elements/CTA'
import { Form } from '@f/elements/HookForm'
import yup from '@f/elements/HookForm/validator/yup'
import Icon from '@f/elements/Icon'

import { conversionFunnelCopy } from '@f-fertighaus/applications/RequestWizard/partials/utils'
import { Gender } from '@f-fertighaus/applications/SalesAgentDashboard/config'
import { GenderType } from '@f-fertighaus/applications/SalesAgentDashboard/SalesAgentDashboardData'
import { $TSFixMe } from '@f-fertighaus/applications/UserAccount/interfaces/utils'

import { WizardRequestType } from '../partials/wizardConstants'
import { Data, User } from './dataType'

interface UserNameSchema {
  gender: GenderType
  first_name: string
  last_name: string
}

interface UserNameProps {
  actions: $TSFixMe
  data: Data
  user?: User
  requestType: WizardRequestType
}

const validationSchema: yup.ObjectSchema<UserNameSchema> = yup.object().shape({
  gender: yup
    .mixed()
    .oneOf([...Gender, ''])
    .required(validationMessage.gender.required),
  first_name: yup.string().firstName(),
  last_name: yup.string().lastName()
})

const UserName = (props: UserNameProps) => {
  useEffect(() => {
    props.actions.update_wtValue({ value: 'gender-name' })
  }, [])

  const { gender, first_name = '', last_name = '' } = props.data.user

  const handleSubmit = (values: UserNameSchema) => {
    props.actions.handleUserDataChange({ detail: values })
    props.actions.move({})
  }

  return (
    <Form.Wrapper<UserNameSchema>
      className='RequestWizard-form-wrapper'
      validationSchema={validationSchema}
      defaultValues={{
        first_name: first_name,
        last_name: last_name,
        gender: gender
      }}
      onSubmit={handleSubmit}
      wtData={{
        form: {
          location: 'modal-gender-name',
          ...props.data.trackingInfo
        }
      }}
      data-wtloc='modal-gender-name'>
      <div className='RequestWizard-top'>
        <div className='RequestWizard-heading'>
          <div className='[ f-t-tmedium f-c-fo-pri f-t-centre f-p-h-080:m ]'>
            {conversionFunnelCopy['vendor-wizard-item'].step_1.header}
          </div>
        </div>

        <div className='RequestWizard-content'>
          <Form.Radio
            className='[ f-m-b-010 f-d-flr f-fl-gap-010 ]'
            radioTheme='basic'
            radioLabelClassName='f-m-l-010'
            radioClassName='[ f-c-ba-whi f-c-fo-pri f-c-bo-neu025 f-m-r-005 ]'
            radioActiveClassName='[ f-c-ba-whi f-c-fo-pri f-c-bo-pri ]'
            name='gender'
            radioOptions={GENDER_RADIO_INPUT_VALUES}
            wtData={{
              radiobutton: {
                location: 'modal-gender-name',
                ...props.data.trackingInfo
              }
            }}
          />
          <div className='RequestWizard-columns-wrapper'>
            <div className='[ f-d-flr ] RequestWizard-columns'>
              <div className='RequestWizard-column'>
                <Form.Text
                  name='first_name'
                  className='[ f-m-b-010 f-c-bo-neu025 ] has-border'
                  placeholder='Vorname'
                  inputProps={{ 'data-sel': 'ipt-fname' }}
                />
              </div>
              <div className='RequestWizard-column'>
                <Form.Text
                  name='last_name'
                  className='[ f-m-b-010 f-c-bo-neu025 ] has-border'
                  placeholder='Nachname'
                  inputProps={{ 'data-sel': 'ipt-lname' }}
                />
              </div>
            </div>
          </div>
          <p className='[ f-t-mini f-c-fo-neu200 f-m-v-020 f-d-bl f-t-centre ]'>
            <Icon
              icon='lock-16px'
              className='[ f-d-inbl f-m-r-005 f-icon-020 f-c-st-inherit ]'
            />
            Ihre Daten werden sicher und SSL-verschlüsselt übertragen.
          </p>
        </div>
      </div>
      <div className='RequestWizard-bottom'>
        <CTA
          type='block-primary'
          tag='button'
          buttonType='submit'
          data-sel='btn-cta'
          className='[ f-m-h-auto f-m-t-020 ] is-block:s'
          wtData={{
            'CTA-click': {
              ...props.data.trackingInfo
            }
          }}>
          {conversionFunnelCopy['vendor-wizard-item'].step_1.ctaText}
        </CTA>
      </div>
    </Form.Wrapper>
  )
}

export default UserName
